import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../Components/Navbar/Navbar';
import toast from 'react-hot-toast';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Layout,
  Col,
  Row,
  Button,
  Dropdown,
  Space,
  Modal,
  Form,
  Input,
  Table,
  Select,
  Menu,
  InputNumber,
  DatePicker,
} from 'antd';
import {
  BorderColor 
} from '@mui/icons-material';
import dayjs from 'dayjs';
import { ExclamationCircleFilled, ProductOutlined } from '@ant-design/icons';

import { UseGetRequest } from '../../Utils/api/ApiRequests';
import { usePostRequest } from '../../hooks/usePostRequest';

const { RangePicker } = DatePicker;
const { Search, TextArea } = Input;
const { Item, List } = Form;
const { Option } = Select;
const { confirm } = Modal;

const Player = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [tournament, setTournament] = useState([]);
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editTournament, setEditTournament] = useState(false);
  const [individualId, setIndividualId] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [action, setAction] = useState("");
  const [playerId, setPlayerId] = useState('');
  const [editTournamentForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;
  const [individualDetails, setIndividualDetails] = useState({
    name: '',
    date: '',
    remarks: '',
  });

  const [playerDetails, setPlayerDetails] = useState({
    name: '',
    date:'',
    remarks:'',
});

  const [filterConfig, setFilterConfig] = useState({
    individual_player_id: '',
    tournament_id: id,
    page: 1,
  })

  const [playerData, setPlayerData] = useState([]) 
  const [editForm] = Form.useForm();
  const [addForm] = Form.useForm();
  const { RangePicker } = DatePicker;

  const columns = [
    {
      title: 'Players',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'HDC',
      dataIndex: 'hdc',
      key: 'hdc',
      align: 'center',
      sorter: (a, b) => a.hdc.localeCompare(b.hdc),

    },
    {
      title: 'Division',
      dataIndex: 'division_name',
      key: 'division_name',
      align: 'center',
      sorter: (a, b) => a.division_name.localeCompare(b.division_name),
    },
  ];

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
    ));
  }; 

  const showAddModal = () => {
    setAddVisible(true);
  };

  

  const menu = (
    <Menu>
      <Menu.Item 
        onClick={showAddModal} 
        key="1"
      >
        Add Player
      </Menu.Item>
      <Menu.Item 
        onClick={() => navigate('/individualstrokeplay/scorecard')}
        key="2"
      >
        Add Score
      </Menu.Item>
    </Menu>
  );

    const validateSpaces = (_, value) => {
        if (value && value.trim().length === 0) {
        return Promise.reject('Please enter a value other than spaces');
        } else {
        return Promise.resolve();
        }
    };
  const { callPost, loading, data } = usePostRequest(()=>{
    fetchPlayerData()
    addForm.resetFields();
    editForm.resetFields();
    editTournamentForm.resetFields();
    setAddVisible(false);
    setEditVisible(false);
    setEditTournament(false)
    setIsDisabled(true)
  });
  
  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      // total_records_per_page: pagination.pageSize,
    }));
  };

  async function fetchTournamentData() {
    setIsLoading(true)
    const response = await UseGetRequest("tournaments/get",{tournament_id: id});
    if (response?.data) {
      setTournament(response?.data?.data[0]);
    } else {
      setTournament([])
    }

    setIsLoading(false);
  }

  const handleEditTournamentClose = () => {
    setEditTournament(false)
    setIsDisabled(true)
  };

  const handleEditTournament = () => {
    editTournamentForm.validateFields().then(values => {
      const data = {
        name: values.name,
        remarks: values.remarks || '',
        date_from: values.date[0].format('YYYY-MM-DD'),
        date_to: values.date[1].format('YYYY-MM-DD'),
        division_names: values?.divisions?.map((item)=>item.division_names),
        game_type: "Individual Strokeplay",
        tournament_id: individualId
      }
      var finalValues = Object.entries(data).map(([key, value]) => ({
        key,
        value,
    }));
      callPost(
        "tournaments/update", 
        finalValues,
        true
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showDeleteTournament= (id) => {
    confirm({
      title: 'Do you want to permanently remove this Tournament?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        setAction("delete");
        callPost(
          "tournaments/delete", 
          {tournament_id: id},
          false
        );
        setAction("delete")
      },
     
    });
  };

  const showEditTournament = (id, individual_data) => {
    setEditTournament(true);
    setIndividualId(id);
    setIndividualDetails(() => ({
      name: individual_data.name,
      date: [
        individual_data.date_from ? dayjs(individual_data.date_from, 'YYYY/MM/DD') : undefined,
        individual_data.date_to ? dayjs(individual_data.date_to, 'YYYY/MM/DD') : undefined,
      ],
      remarks: individual_data.remarks,
      divisions: individual_data.divisions,
    }));

    editTournamentForm.setFieldsValue({
      name: individual_data.name,
      date: [
        individual_data.date_from ? dayjs(individual_data.date_from, 'YYYY/MM/DD') : undefined,
        individual_data.date_to ? dayjs(individual_data.date_to, 'YYYY/MM/DD') : undefined,
      ],
      remarks: individual_data.remarks,
      divisions: individual_data.divisions,
    });
  };

  const showEditModal = (id, individual_data) => {
    setPlayerId(id) 
    setPlayerDetails(() => ({
      division_name: individual_data.division_id,
      team_name: individual_data.team_name,
      member: individual_data?.players?.filter(item => item?.player_type === "member")?.map(item => item?.name),
      member_id: individual_data?.players?.filter(item => item?.player_type === "member")?.map(item => item?.id),
      member_hdc: individual_data?.players?.filter(item => item?.player_type === "member")?.map(item => item?.hdc),
    //   guest: individual_data?.players?.filter(item => item?.player_type === "guest")?.map(item => item?.name),
    //   guest_id: individual_data?.players?.filter(item => item?.player_type === "guest")?.map(item => item?.id),
    //   guest_hdc: individual_data?.players?.filter(item => item?.player_type === "guest")?.map(item => item?.hdc),
    }));     
    
    editForm.setFieldsValue({
      division_name: individual_data.division_id,
      team_name: individual_data.team_name,
      member: individual_data?.players?.filter(item => item.player_type === "member").map(item => item.name),
      member_id: individual_data?.players?.filter(item => item.player_type === "member").map(item => item.id),
      member_hdc: individual_data?.players?.filter(item => item.player_type === "member").map(item => item.hdc),
    //   guest: individual_data?.players?.filter(item => item.player_type === "guest").map(item => item.name),
    //   guest_id: individual_data?.players?.filter(item => item.player_type === "guest").map(item => item.id),
    //   guest_hdc: individual_data?.players?.filter(item => item.player_type === "guest").map(item => item.hdc),
    });
    setEditVisible(true);
  };

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("individual_strokeplay_players/get", filterConfig);
    if (response?.data) {
      setPlayerData(response?.data?.data);
      setPageSize(response?.data?.size)
    } else {
      setPlayerData([])
    }

    setIsLoading(false);
  }

  useEffect(() => {
    fetchTournamentData();
  }, [id]);

  useEffect(() => {
    fetchPlayerData();
  }, [filterConfig]);

  // const handleAddOk = () => {
  //   addForm.validateFields().then(values => {
  //       const memberData = values?.member.map((item, index) => {
  //           return {
  //             name: item,
  //             id: values?.member_id[index],
  //             hdc: values?.member_hdc[index],
  //             player_type: "member"
  //           }
  //         });
  //       callPost(
  //           "individual_player/add",
  //       {
  //         tournament_id: id,
  //         division_id: values.division_name,
  //         players: memberData,
  //       },
  //       false
  //     );
  //   });
  // };
  const handleAddOk = () => {
    addForm.validateFields().then(values => {
      const data = {
        division_id: values.division_name,
        names: values.members.map((item)=>item.member),
        hdcs: values.members.map((item)=>item.member_hdc),
      }
      var finalValues = Object.entries(data).map(([key, value]) => ({
          key,
          value,
      }));

      callPost(
        "/individual_strokeplay_players/add_multiple",
        finalValues,
        true
      );
    });
};

//             "individual_players/add", 
//             finalValues,
//             true
//         );
//     }).catch(errorInfo => {
//       toast.error('Validation Failed:', errorInfo);
//     });
//   };

    const handleAddCancel = () => {
        setAddVisible(false);
        addForm.resetFields();
    };

  return (
    <Layout className='page'>
      <Navbar navKey={'individual_strokeplay'} />
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={15} className='header-container'>
            <Space>
                {tournament?.name?.toUpperCase()}
              <BorderColor className='cursor' onClick={() => showEditTournament(id, tournament)} />
            </Space>
          </Col>
          <Col span={9} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'> 
                <Search
                  placeholder="Search..."
                  size='medium'
                  onChange={(e)=>onSearch(e)}
                  className='responsive-header-input'
                />      
                <Dropdown
                  overlay={menu}
                  trigger={['click']}
                >
                  <Button type="primary" onClick={(e) => e.preventDefault()}>
                    <Space>
                      + Add
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
        </Row>
        <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
               <Table 
                columns={columns} 
                dataSource={playerData} 
                loading={{
                  indicator: customSpinner, // Use custom spinner
                  spinning: isLoading, // Set spinning based on loading state
                }}
                pagination={{
                  defaultPageSize: 10,
                  // showQuickJumper: true,
                  // showSizeChanger: true,
                  total: pageSize,
                  current: filterConfig?.page,
                  pageSize: filterConfig?.total_records_per_page,
                }}
                onChange={handleTableChange}
                onRow={(record, rowIndex) => {
                  return {
                    className: 'cursor',
                    onClick: () => showEditModal(record.id, record),
                  };
                }}
              />
            </Col>
          </Row>
      </Layout>
      <Modal
    title="Add Player"
    confirmLoading={loading}
    open={addVisible}
    onOk={handleAddOk}
    onCancel={handleAddCancel}
    okText="Submit"
    maskClosable={false}
  >
    <Row>
      <Col span={24} align="center">
        {tournament.name}
      </Col>
    </Row>
    <Form form={addForm} layout="vertical" initialValues={{ members: [{ member: '', member_hdc: 0 }] }}>
      <Item
        label="Division"
        name="division_name"
        rules={[
          { required: true, message: 'Please enter your Division Name!' },
        ]}
      >
        <Select
          placeholder="Select a division"
          showSearch
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {tournament?.divisions?.map((option) => (
            <Option key={option.division_id} value={option.division_id}>
              {option.division_names}
            </Option>
          ))}
        </Select>
      </Item>
      <Form.List name="members">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Space key={field.key} align="baseline">
                <Item
                  {...field}
                  label="Player"
                  name={[field.name, 'member']}
                  rules={[
                    { required: true, message: 'Please enter your Player Name!' },
                  ]}
                >
                  <Input />
                </Item>
                <Item
                  {...field}
                  label="HDC"
                  name={[field.name, 'member_hdc']}
                >
                  <InputNumber min={0} max={28} />
                </Item>
                {fields.length > 1 && (
                  <MinusCircleOutlined onClick={() => remove(field.name)} />
                )}
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add Player
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  </Modal>
        <Modal
        title="Edit Tournament"
        confirmLoading={loading}
        open={editTournament}
        // onOk={handleEditTournament}
        onCancel={handleEditTournamentClose}
        okText="Save"
        maskClosable={false}
        footer={null}
        className='edit-modal'
      >
        <Form 
          form={editTournamentForm} 
          layout="vertical"
          initialValues={individualDetails}
        >
         
          <Row>
            <Col span={11}>
              <Item
                  label="Name"
                  name="name"
                  rules={[
                  { required: true, message: 'Please enter your Name!' },
                  { validator: validateSpaces }
                  ]}
                  
              >
                  <Input disabled={isDisabled} />
              </Item>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <Item
                label="Date"
                name="date"
                rules={[
                    { 
                        required: true, message: 'Please enter your Date Range!' 
                    },
                ]}
              >
                <RangePicker  
                    style={{width:'100%'}}
                    placeholder={['Date From', 'Date To']}
                    format={'YYYY/MM/DD'}
                    disabled={isDisabled}
                />
              </Item>
            </Col>
          </Row>
          <Item
              label="Remarks"
              name="remarks"
          >
              <TextArea rows={3} disabled={isDisabled}/>
          </Item>
          <label className='mb-2'><span className='logout-icon me-1'>*</span>Divisions</label>
          <List label="Division" name="divisions">
              {(fields, { add, remove }) => (
                  <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                          <Row key={key} style={{ display: 'flex', marginBottom: 8}} align="baseline">
                            <Col span={11}>
                              <Item
                                {...restField}
                                name={[name, 'division_names']}
                                fieldKey={[fieldKey, 'division_names']}
                                rules={[{ required: true, message: 'Please input division!' }]}
                               >
                                <Input 
                                    placeholder="Enter Division" 
                                    style={{
                                        width: '100%',
                                    }}
                                    disabled={isDisabled}
                                />
                              </Item>
                            </Col>
                            <Col span={1}></Col>
                            <Col span={11}>
                              {fields.length > 1 ? (
                                <MinusCircleOutlined className='logout-icon' onClick={() => remove(name)} />
                              ) : null}
                            </Col>
                          </Row>
                      ))}
                      <Item>
                          <Button disabled={isDisabled} type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                              Add Division
                          </Button>
                      </Item>
                  </>
              )}
          </List>
        </Form>
        <Row>
         <Col span={24} align='right'>
          <Space>
            <Button
              className='delete-btn'
              onClick={() => showDeleteTournament(id)}
            >
              Delete
            </Button>
            {
              isDisabled ? (
                <Button
                  className='edit-btn'
                  onClick={() => setIsDisabled(false)}>
                  Edit
                </Button>
              ) : (
                <Button 
                  className='edit-btn'
                  onClick={() => setIsDisabled(true)}
                >
                  View
                </Button>
              )
            }
            {
              !isDisabled && (
                <Button 
                  className='edit-btn'
                  onClick={handleEditTournament}
                >
                  Save
                </Button>
              )
            }
          </Space>
         </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default Player;
